import React from 'react';

import IconType from 'types/Icon';

export const AttentionIcon: React.FC<IconType> = ({ color = 'currentColor', size = 24 }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none">
		<path
			d="M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM12 4C16.418 4 20 7.582 20 12C20 16.418 16.418 20 12 20C7.582 20 4 16.418 4 12C4 7.582 7.582 4 12 4ZM11 7V13H13V7H11ZM11 15V17H13V15H11Z"
			fill={color}
		/>
	</svg>
);
